module.exports = __webpack_public_path__ + "img/DE04345.1d7d115d.png";